import {Component, Input, OnInit} from '@angular/core';
import { DraftDepotRequeteService } from '../../../depot-requete/draft-depot-requete.service';
import { EventPieceJointe } from '../../../entities/piece-jointe';
import { saveOrOpenRawFile } from '../../core/util';
import { ErrorEnum } from '../../constants/error.constants';

@Component({
    selector: 'jhi-preview-piece',
    template: `
    <div class="input-group">
    <ng-container *ngIf="showLabel">
        <input type="text" class="form-control" id="{{id}}" readonly [value]="piece.libelle">
    </ng-container>
    <ng-container *ngIf="!showLabel">
        <input type="text" class="form-control" readonly [value]="piece.fileName">
    </ng-container>
    <button class="input-group-addon pointer no-border" aria-label="visualiser la pièce">
        <i class="fa fa-download" aria-hidden="true" (click)="visualiserPiece()" title="visualiser la pièce"></i>
        <span class="sr-only">Visualiser la pièce</span>
    </button>
    <jhi-message *ngIf="errorTrFonctionnel">
        <span>Nous rencontrons actuellement un problème technique qui ne permet pas l'accès à ce document.
            L'incident est en cours de résolution. Nous vous invitons à réessayer dans 24h.</span>
    </jhi-message>
</div>
    `,
    styles: [` .input-group-addon {
        background: transparent;
        border: 0;
    }
    .pointer {
        cursor: pointer;
    }
    button.no-border {
        border: none;
    }
    `]
})
export class PreviewPieceComponent implements OnInit {

    @Input() piece: EventPieceJointe;

    @Input() showLabel = false;

    @Input() id: string;

    errorTrFonctionnel: boolean;

    constructor(private  draftDepotRequeteService: DraftDepotRequeteService) {
    }

    ngOnInit() {
    }

    visualiserPiece() {
        this.draftDepotRequeteService.downloadJustificatif(this.piece.fileApiId)
            .subscribe(blob =>  saveOrOpenRawFile(blob, `${this.piece.libelle}.pdf`),
                error => {
                    if (error.errorType === ErrorEnum.TR_FUNCTIONAL_ERROR) {
                        this.errorTrFonctionnel = true;
                    }
                });
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/components/preview-piece/preview-piece.component.ts